export default __webpack_public_path__ + "static/media/index-img4.364bea49.jpeg";